const travellerProto = require('./mytrips_traveller');
const utils = require('od-modules/xsell/utils');

function confirmationTraveller(traveller) {
    const that = Object.create(travellerProto(traveller));

    that.getAgeType = function() {
        return traveller.ageType;
    };

    that.getAge = function() {
        const timestamp = Odigeo._.get(traveller, 'birthDate', 0);

        return utils.getAge(timestamp);
    };

    that.getCountryCodeOfResidence = function() {
        return Odigeo._.get(traveller, 'localityCodeOfResidence', '');
    };

    that.getBaggagesInArrival = function() {
        return Odigeo._.get(traveller, 'baggageSelectionDTOs[0].regularSelectableBaggageDescriptor.baggageDescriptor.pieces', 0);
    };

    that.getBaggagesInDeparture = function() {
        return Odigeo._.get(traveller, 'baggageSelectionDTOs[1].regularSelectableBaggageDescriptor.baggageDescriptor.pieces', 0);
    };

    return that;
}

module.exports = confirmationTraveller;

